import AutoAbstractField from "./AutoAbstractField.mjs";
import autoFormHelper from "../helperLibs/autoFormHelper.mjs";
import AutoFormFields from "../AutoFormFields.mjs";
import G from "../../libs/Glob.mjs";
import {Button} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import TrashIcon from "../../media/images/TrashIcon.mjs";
import AddIcon from "../../media/images/AddIcon.mjs";

const AutoMultiGroupField = class extends AutoAbstractField {
	constructor(props) {
		super(props);
		let v = G.clone(this.state.value) || [];
		if ( ! Array.isArray(v) ) v = [v];
		this.state.value=v;
		this.state.forms = v.map((u, i) => (
			new autoFormHelper(
				{
					parent: this.state.fh,
					fields: G.clone(this.props.def.fields||[]),
					index: i,
					data: u || {}
				}
			)
		));
		this.state.refreshAll = Date.now();
		this.addMultiField = this.addMultiField.bind(this);
		this.rmMultiField = this.rmMultiField.bind(this);
	}

	addMultiField() {
		const v = G.clone(this.state.value) || [];
		const f = this.state.forms;
		v.push({});
		const h = new autoFormHelper(
			{
				parent: this.state.fh,
				fields: G.clone(this.props.def.fields||[]),
				index: f.length,
				data: {}
			}
		);
		f.push(h);
		this.setState({ value: v, forms: f });
	}

	rmMultiField( index ) {
		const v = G.clone(this.state.value) || [];
		const f = this.state.forms;
		v.splice(index, 1);
		f.splice(index, 1);
		f.forEach( (h,i) => {
			h.setIndex(i);
		});
		this.setState({ value: v, forms: f, refreshAll: Date.now() }, ()=>{
			this.state.fh.setValue(v);
		});
	}

	renderField() {
		return(
			<>
				{(this.state.value||[]).map((v, i) => (
					<blockquote key={`${this.state.refreshAll}-${i}`}>
						<div className={"multiControls"}>
							<Button
								className={"btn-icon"}
								color={"danger"}
								onClick={ ()=>{ this.rmMultiField(i); }}
							>
								<i>
									<TrashIcon/>
								</i>
							</Button>
						</div>
						<AutoFormFields
							fields={G.clone(this.props.def.fields || [])}
							helper={this.state.forms[i]}
							topHelper={ this.props.topHelper }
							data={v || {}}
						/>
					</blockquote>
				))}
				<div className={"multiControls"}>
					<Button
						className={"btn-icon"}
						onClick={ ()=>{ this.addMultiField(); }}
					>
						<b>
							<TextLabel value={"Add"}/>
						</b>
						<i>
							<AddIcon/>
						</i>
					</Button>
				</div>
			</>
		);
	}
}

export default AutoMultiGroupField;